import { ArticleHeading2, ArticleParagraph1, ModalWindow } from '@cian/ui-kit';
import { TReview } from 'shared/types/reviews';
import * as style from './ReviewModal.css';

interface IReviewModalProps {
  onCloseModal: VoidFunction;
  isOpen: boolean;
  review?: TReview;
}

export const ReviewModal: React.FC<IReviewModalProps> = ({ onCloseModal, isOpen, review }) => {
  return (
    <ModalWindow
      onClose={onCloseModal}
      open={isOpen}
      content={
        <div className={style['container']}>
          <div className={style['title']}>
            <ArticleHeading2>{review?.name}</ArticleHeading2>
          </div>
          {review?.review.map((row, index) => (
            <div key={index} className={style['row']}>
              <ArticleParagraph1>{row}</ArticleParagraph1>
            </div>
          ))}
        </div>
      }
    />
  );
};
